<template>
    <div class="vr_controls" @mouseup="zoomOut" >
        <!-- home -->
        <router-link to="/" class="item" v-if="$route.path != '/'"><img class="icon" src="../assets/images/icon_home.png" alt=""></router-link>
        <div class="item" v-if="!playing" @click="$emit('play', {speed: 1})"><img class="icon" src="../assets/images/icon_play.png" alt=""/></div>
        <div class="item" v-else @click="$emit('pause')"><img class="icon" src="../assets/images/icon_pause.png" alt=""/></div>
        <template v-if="type != 'home'">
            <div class="item" @click="$emit('play', {speed: 1})"><img class="icon" src="../assets/images/icon_play_01.png" alt=""/></div>
            <div class="item" @click="$emit('play', {speed: 2})"><img class="icon" src="../assets/images/icon_play_02.png" alt=""/></div>
        </template>
        <div class="item share">
            <img class="icon normal" src="../assets/images/icon_share.png" alt=""/>
            <img class="icon hover" src="../assets/images/icon_share2.png" alt=""/>
            <div class="share_btn_group_wrap">
                <div class="btn_group">
                    <div class="btn" @click="$emit('showShareWX')"><img src="../assets/images/icon_share_btn_wx.png" alt=""/></div>
                    <div class="btn" @click="shareToTwitter"><img src="../assets/images/icon_share_btn_tw.png" alt=""/></div>
                    <div class="btn" @click="shareToLinkedin"><img src="../assets/images/icon_share_btn_in.png" alt=""/></div>
                    <div class="btn" @click="shareToFacebook"><img src="../assets/images/icon_share_btn_fb.png" alt=""/></div>
                    <a class="btn" :href="`mailto:?subject=${emailSubject}&body=${appPath}`"><img src="../assets/images/icon_share_btn_email.png" alt=""/></a>
                    <div class="btn" @click="$emit('showShareLink')"><img src="../assets/images/icon_share_btn_link.png" alt=""/></div>
                </div>
            </div>
        </div>
        <!-- <div class="item vr" v-if="schoolName == 'shanghai-pudong'">
            <a v-if="yearsActiveIndex == 0" href="https://www.netime.com.cn/vr-demo/pd-vr10/ducks.html" target="_blank">
                <img src="../assets/images/vr.png" alt=""/>
            </a>
            <a v-if="yearsActiveIndex == 1" href="https://www.netime.com.cn/vr-demo/pd-vr10/js.html" target="_blank">
                <img src="../assets/images/vr.png" alt=""/>
            </a>
            <a v-if="yearsActiveIndex == 2" href="https://www.netime.com.cn/vr-demo/pd-vr10/ss.html" target="_blank">
                <img src="../assets/images/vr.png" alt=""/>
            </a>
        </div> -->
        <template v-if="type != 'home'">
            <div class="zoom">
                <img src="../assets/images/icon_size.png" alt="" class="icon">
                <div class="pagination" ref="zoom" @mousedown="zoomDown" @mousemove="zoomMove" @mouseleave="zoomOut"><div class="in" :style="{top: `${zoom}%`}"></div></div>
            </div>
        </template>
        <ShareToLink :show="isShowShareToLink" @close="isShowShareToLink = false"/>
        <ShareToWX :show="isShowShareToWX" @close="isShowShareToWX = false"/>
    </div>
</template>

<script>
import ShareToLink from './shareToLink.vue';
import ShareToWX from './shareToWX.vue';
export default {
    name: "VrControls",
    props: ['playing', 'zoom', 'type'],
    data() {
        return {
            // schoolName: process.env.VUE_APP_NAME,
            appPath: window.location.href, //分享链接地址，当前地址
            // appPath: `${process.env.VUE_APP_DOMAIN_NAME}/${process.env.VUE_APP_NAME}`, //分享链接地址
            zoomChange: false, //选中缩放控件
            emailSubject: process.env.VUE_APP_EMAILSUBJECT, //邮件主题
            isShowShareToLink: false, //分享链接弹窗
            isShowShareToWX: false, //分享二维码弹窗
        };
    },
    computed: {
        // appPath() { 
        //     return window.location.href;
        // },
    },
    components: {
        ShareToLink,
        ShareToWX
        
    },
    mounted() {
        
    },
    watch: {},
    methods: {
        zoomTap(e){
            let offset = this.$refs.zoom.getBoundingClientRect();
            let pagination = (e.pageY - offset.top) / offset.height * 100;
            this.$emit('changeZoomSize', {zoom: pagination});
        },
        zoomDown(e){
            this.zoomChange = true;
            this.zoomMove(e);
        },
        zoomMove(e){
            if(!this.zoomChange){
                return false;
            }
            let offset = this.$refs.zoom.getBoundingClientRect();
            let pagination = (e.pageY - offset.top) / offset.height * 100;
            this.$emit('changeZoomSize', {zoom: pagination});
        },
        zoomOut(){
            this.zoomChange = false;
        },
        shareToFacebook() {
            let url = 'http://www.facebook.com/sharer/sharer.php?u=' + this.appPath;
            let title = 'facebook';
            return window.open(url, title, 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        },
        shareToTwitter(){
            let url = this.appPath;
            let title = 'twitter';
            return window.open('http://twitter.com/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        },
        shareToLinkedin(){
            let url = this.appPath;
            let title = 'linkedin';
            return window.open('https://www.linkedin.com/shareArticle?mini=true&source=str&title=' + title + '&url=' + url, '',  'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.vr_controls{
    position: fixed;
    top: 1.3rem;
    right: .5rem;
    z-index: 100;
    .item{
        display: block;
        width: .5rem;
        margin-bottom: .24rem;
        background: rgba($color: #c5011b, $alpha: .8);
        border-radius: 50%;
        position: relative;
        .icon{
            cursor: pointer;
            width: 100%;
        }
        &.share{
            transition: background-color .3s;
            .hover{
                display: none;
            }
            &:hover{
                .normal{
                    display: none;
                }
                .hover{
                    display: block;
                }
                background: rgba($color: #fff, $alpha: .8);
                .share_btn_group_wrap{
                    opacity: 1;
                    visibility: visible;
                    transform: translate(0, -50%);
                }
            }
        }
        &.vr{display: none;}
    }
    .zoom{
        width: .5rem;
        .icon{
            width: .28rem;
            height: .28rem;
            margin: 0 auto .12rem;
        }
        .pagination{
            position: relative;
            margin: 0 auto;
            width: 100%;
            height: 1.6rem;
            cursor: pointer;
            &::after{
                content: "";
                position: absolute;
                width: .05rem;
                height: 100%;
                background: #fff;
                border-radius: .05rem;
                left: 50%;
                transform: translate(-50%, 0);
            }
            .in{
                position: absolute;
                width: .2rem;
                height: .05rem;
                background: #fff;
                border-radius: .05rem;
                top: 0;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    .share_btn_group_wrap{
        padding-right: .2rem;
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translate(10%, -50%);
        opacity: 0;
        visibility: hidden;
        transition: transform .3s, opacity .3s, visibility .3s;
        .btn_group{
            width: 1.2rem;
            display: flex;
            flex-wrap: wrap;
            background: rgba($color: #000000, $alpha: .7);
            border-radius: .08rem;
            .btn{
                width: 50%;
                cursor: pointer;
            }
        }
    }
    @media only screen and (max-width: 640px) {
        // right: auto;
        // top: auto;
        right: .3rem;
        top: 2rem;
        .item{
            width: .6rem;
            &.vr{display: block;}
        }
        .zoom{
            display: none;
        }
    }
}
</style>